//统一管理api
import { base_game } from "./base"; // 导入接口域名列表
import { get } from "./tool"; // 导入http中创建的axios实例

export const getUsersCount = (params) => get(base_game + "/users/count", params);

export default { getUsersCount };
